import { FC } from "react";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import {
  Box,
  Grid,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import useStyles from "../Styles/PopOverStyles";
import { PopoverProps } from "../../interfaces";
import JoinGainspad from "../../assets/images/join-gainspad.jpg";
import ClaimImage from '../../assets/images/claimtutorial.jpg';
import BuyGains from '../../assets/images/buy-gains-tutorial.jpg';
import Play from "../../assets/images/play.svg"
import { FaListOl, FaTelegram } from "react-icons/fa";
import { Colors } from "../../helpers/theme";
import { useHistory } from "react-router";

const tutorials = [
  {
    title: "How to Buy Gains",
    url: "https://youtu.be/n4hSKZqwsD0?si=oCnDDi8YxFfWBH9x",
    text: "Step-by-step instructions",
    image: BuyGains,
  },
  {
    title: "How to Participate in GainsPad",
    url: "https://www.youtube.com/watch?v=UF42JHS-eFA",
    text: "Step-by-step instructions",
    image: JoinGainspad,
  },
  {
    title: "How to Claim/Get Refunded",
    url: "https://youtu.be/pZZR9AoFAlw",
    text: "Step-by-step instructions",
    image: ClaimImage,
  },
];


const TutorialCard = ({title, url, text, image}:
  {title: string, 
   url: string, 
   text: string, 
   image: any
  }) => {

  const classes = useStyles();

  return (
          <Box
            className={classes.tutorialCard}
          >
            <a style={{position:"relative"}} href={url} target="_blank" rel="noreferrer"> 
            <img
              src={image}
              alt={title}
              
            />
            <Box
             className="play-icon"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.6663 7.99998L3.33301 1.33331V14.6666L14.6663 7.99998Z" fill="white"/>
                  </svg>

                </Box>
            </a>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="body1">{text}</Typography>
          </Box>
      
  );
}

const TutorialsPopover: FC<PopoverProps> = ({
  id,
  open,
  anchorEl,
  handleClose,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const redirectToGuidePage = () => {
    window.open('/ido-step-by-step', '_blank');
  }

  const openTelegramSupport = () => {
    window.open('https://t.me/+tIwaCtq58KthMDQ8', '_blank');
  }

  return (
    <>
      <Popover
        className={classes.tutorialsPopover}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        disableScrollLock={false}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Grid container style={{ padding: '1rem', maxWidth: isActive ? '24rem' : '48rem' }} justifyContent="flex-start">
            <Typography variant="h2">Tutorials</Typography>
            <Grid container style={{ justifyContent: isActive ? 'center' : 'space-between', width: 'auto' }} spacing={2}>
              {
                tutorials.map((tutorial,i) => (
                  <Grid item key={i} lg={4} md={6} sm={12}>
                    <TutorialCard  
                      title={tutorial.title}
                      url={tutorial.url}
                      text={tutorial.text}
                      image={tutorial.image}  
                    />
                  </Grid>
                ))
              }
            </Grid>
            <Typography variant="h2" style={{ marginTop: '20px', marginBottom: '10px' }}>Other Resources</Typography>
            <Grid container style={{ justifyContent: isActive ? 'center' : 'space-between', width: '100%' }} spacing={2}>
              <Grid item xs={12} md={6} onClick={redirectToGuidePage}>
                <Box className={classes.tutorialResources}>
                  <FaListOl size={30} />
                  <Typography variant="subtitle1" style={{ marginLeft: "10px" }}>Step by Step Guide</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} onClick={openTelegramSupport}>
                <Box className={classes.tutorialResources}>
                  <FaTelegram size={30} />
                  <Typography variant="subtitle1" style={{ marginLeft: "10px" }}>Admin Support</Typography>
                </Box>
              </Grid>
            </Grid>
        </Grid>
      </Popover>
    </>
  );
};
export default TutorialsPopover;
